import { createTheme } from '@mui/material';

const environment = process.env.REACT_APP_ENV;

const returnEnvTheme = () => {
  switch (environment !== undefined) {
    case 'local' === environment:
      return { light: '#f75e2a', dark: '#f75e2a' };
    case 'dev' === environment || 'development' === environment:
      return { light: '#f75e2a', dark: '#f75e2a' };
    case 'test' === environment:
      return { light: '#dd0031', dark: '#e22650' };
    case 'beta' === environment:
      return { light: '#004f71', dark: '#3eb1c8 ' };
    case 'prod' === environment || 'production' === environment:
      return { light: '#004f71', dark: '#3eb1c8 ' };
    default:
      return { light: '#004f71', dark: '#3eb1c8 ' };
  }
};

const muiTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: returnEnvTheme().light,
    },
  },
});

const appTheme = { theme: muiTheme, pallete: returnEnvTheme() };

export default appTheme;
